import { FETCH_MORE_PRODUCTS_FAILURE } from './../const';

export default () => {
  return {type: FETCH_MORE_PRODUCTS_FAILURE}
};
